import axios from "axios";

const instance = axios.create({
  baseURL: "/api",
});

instance.defaults.method = "POST";
instance.defaults.withCredentials = true;
instance.defaults.responseType = "json";

// The server now refuses a request for a page the company has no right to. No caller
// has a .catch, so a rejected promise would just leave a spinner running forever.
// A 403 means the client is working from stale rights (a tab left open across a change),
// so reload: that refreshes the token, rebuilds the menu, and lands the user on the
// "request access" page instead of a screen that never finishes loading.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      document.location.reload();
    }
    return Promise.reject(error);
  }
);

export default instance;
